
export function TimeFilter(ms, format) {
  ms = Math.min(ms, 356400000);
  ms = Math.max(ms, 0);
  let M, h, m, s, hh, mm, ss;
  s = ~~(ms / 1000);
  m = ~~(s / 60);
  h = ~~(m / 60);
  ss = s % 60;
  mm = m % 60;
  hh = h % 60;
  let o = {
    'h+': hh.toString(),
    'm+': mm.toString(),
    's+': ss.toString(),
    'M+': m.toString()
  };
  for (let k in o) {
    let reg = new RegExp(`(${ k })`);
    if (reg.test(format)) {
      let replacement = o[k].padStart(RegExp.$1.length, '0');
      format = format.replace(reg, replacement);
    }
  }
  return format;
}
